/* eslint-disable */
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import Header from '../Layouts/Header';
import MenuSidebar from '../Layouts/MenuSidebar';
import { apiUrl} from'../Config/Config';
import axios from 'axios';
import { PageTitle } from "../Helpers/SettingHelper";
// import "../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import BootstrapTable from 'react-bootstrap-table-next';
import cellEditFactory, { Type } from 'react-bootstrap-table2-editor';
import $ from "jquery";
import parser from  'html-react-parser';
import { lang } from '../Helpers/lang';

class Loantypes extends Component {
	
	constructor(props)
	{
		super(props);	
		this.state = {
			Loading: false,
			lt_data: '',
			selectedOption:{ value: 'active', label: 'Active'},

		};
		var qs = require('qs');
		
		var postobject = {
			admin_id:  localStorage.getItem("admin_id")
		};

		axios.post(apiUrl+"loantypes/list",qs.stringify(postobject)).then(res => {
				if(res.data.lt_obj){					
					var lt_obj = res.data.lt_obj;						
					console.log(lt_obj, 'lt_obj');

					var action = sts = "-";

					var lt_arr_obj = [];
					for(var i=0; i<lt_obj.length; i++){

						if(res.data.data == "yes"){
							var sts_icon = '<i style="cursor: pointer" id="'+ lt_obj[i]['id'] +'" data-status="A" class="fa fa-lock changeStatus"></i>';
							var sts = 'Inactive';
							if(lt_obj[i]['status'] == 'A'){ 
								sts = 'Active'; 
								sts_icon = '<i style="cursor: pointer" id="'+ lt_obj[i]['id'] +'" data-status="I" class="fa fa-unlock changeStatus"></i>';
							}
							action = parser(sts_icon + '&nbsp; <i style="cursor: pointer" id="'+ lt_obj[i]['id'] +'" class="ft-trash-2 deleteRow"></i>');
						}
						let sno = i+1;
						lt_arr_obj[i] = { 
							id: lt_obj[i]['id'], 
							sno: sno, 
							name:lt_obj[i]['name'], 
							category:lt_obj[i]['category'], 
							requirements:lt_obj[i]['requirements'], 
							sort_order: lt_obj[i]['sort_order'], 
							status: sts, 
							action: action
						};
					}
					this.setState({lt_data:lt_arr_obj});
					console.log(lt_arr_obj, 'lt_arr_obj');
				}
			});
		this.handleInputChange  = this.handleInputChange.bind(this);
		
    }

    handleInputChange(event) {

      const {name, value} = event.target;      
      this.setState({
          [name]: value
        });
    }
	
    componentDidMount() {
		document.title = PageTitle('Loan Types');
		if(localStorage.getItem('admin_id') === null){
		this.props.history.push('/');
		}
		let body = document.querySelectorAll("body")[0];
		if(localStorage.getItem('admin_id')){
			body.classList.remove("body-theme");
		}else{
			body.classList.add("body-theme");
		}
		$(document).ready(function () {	
			$('#bt-table').on('click', '.add-db', function () {
				var parent = $(this).parents('tr');
				var name = parent.find('#new_lt_name').val();
				var sort_order = parent.find('#new_lt_sort').val();
				var requirements = parent.find('#new_lt_requirements').val();
				var category = parent.find('#category').val();

				var qs = require('qs');
				var postObject = {
					admin_id:  localStorage.getItem("admin_id"),
					name: name,
					requirements: requirements,
					category: category,
					sort_order: sort_order
				};

				if(name != "" && sort_order != ""){
					axios.post(apiUrl+"loantypes/add", qs.stringify(postObject)).then(res => {
						if(res.data.status == "success"){
							window.location.reload();
						}else{
							$('.success_message').html('<div class="status_sucess"><h3>'+ res.data.message+'</h3></div>');
						}
					});
				}else{
					alert('Please fill all the fields');
				}
			});

			
			$('#bt-table').on('click', '.deleteRow', function () {
				var id = $(this).attr('id');
				console.log(id, 'test');
				var confirm = window.confirm('Are you sure you want to delete this?');
    			if(confirm == true){
					var qs = require('qs');
					var postObject = {
						id:  id
					};
					axios.post(apiUrl+"loantypes/delete", qs.stringify(postObject)).then(res => {
						if(res.data.status == "success"){
							window.location.reload();
						}else{
							$('.success_message').html('<div class="status_sucess"><h3>'+ res.data.message+'</h3></div>');
						}
					});
				}
			});
			
			$('#bt-table').on('click', '.changeStatus', function () {
				var id = $(this).attr('id');
				var status = $(this).attr('data-status');
				console.log(id, 'test');
				var qs = require('qs');
				var postObject = {
					id:  id,
					status: status
				};
				axios.post(apiUrl+"loantypes/changestatus", qs.stringify(postObject)).then(res => {
					if(res.data.status == "success"){
						window.location.reload();
					}else{
						$('.success_message').html('<div class="status_sucess"><h3>'+ res.data.message+'</h3></div>');
					}
				});
			});
		});

     }
	 
   	saveCellData(oldValue,newValue,row,column){
		console.log(oldValue, 'oldValue'); 
		console.log(newValue, 'newValue'); 
		console.log(row, 'row'); 
		console.log(column, 'column'); 
		var qs = require('qs');
		axios.post(apiUrl+"loantypes/update", qs.stringify(row)).then(res => {
			if(res.data.status == "success"){
				$('.success_message').html('<div class="status_sucess"><h3>'+ res.data.message+'</h3></div>');
			}else{
				$('.success_message').html('<div class="status_sucess"><h3>Something went wrong</h3></div>');
			}

			setTimeout(
				function() {
					$('.success_message').html('');
				}
				.bind(this),
				3000
			);
		});
  	}

	addNewRow(){
		var selectedOption = lang.common.loantype_option;

		var selecttag = '<select  id="category">';
		selectedOption.forEach(function(val1, index1) {
			selecttag += '<option value="' + val1['value'] + '">' + val1['label'] + '</option>';
		});

		selecttag += '</select>';

		var tableFields = '<tr><td></td><td><input type="text" id="new_lt_name" class="form-control"></td><td>'+selecttag+'</td><td><textarea id="new_lt_requirements" class="form-control"></textarea></td><td><input type="number" id="new_lt_sort" class="form-control"></td><td></td><td><button class="add-db"><i class="fa fa-plus"></i></button></td></tr>';
		$('.react-bootstrap-table').find('tbody').prepend(tableFields);
		$('#add_new_row').attr('disabled', true);
	}

	handleBeforeSaveCell = (oldValue, newValue, row, column, done) => {
		if (column.dataField === 'category') {
			// Handle the category column edit here
			// You may open a select box or use any other method to update the value
			const updatedRow = { ...row, category: newValue };
			// Call done() when you're finished editing the cell
			done(true, updatedRow);
		} else {
			done(true);
		}
	};

	render() {		

		const datas = this.state.lt_data;

		const columns = [
			{dataField: 'id', text: 'ID', hidden: true}, 
			{dataField: 'sno', text: 'S.No', editable: false}, 
			{dataField: 'name', text: 'Loan', align: 'left'}, 
			{dataField: 'category', text: 'Category ', align: 'left', editor: { type: Type.SELECT, options: lang.common.loantype_option }}, 
			{dataField: 'requirements', text: 'Documents Requirement', align: 'left'}, 
			{dataField: 'sort_order', text: 'Priority', type: 'number', sort: true},
			{dataField: 'status', text: 'Status', editable: false},
			{dataField: 'action', text: 'Actions', editable: false}
		];

		let mystyle = {
		    color: "white",
		    backgroundColor: "#000000",
		    padding: "10px",		  
			minWidth: "49px",
			height: "37px",
			lineHeight: "0px",
			textTransform: "capitalize"
	
		};

		return (
		<div className="wrapper"> 
	
		<Header />
		<MenuSidebar currentpage="loantypes" />	

		
		<div className="content">	
			<div className="content-wrapper">
			<div className="content-wrapper-before"></div>
				<div className="content-body setting-main-head leaa-admin-head card">
				{/* <form className="settings"> */}
				<div className="form-wrapper" style={{textAlign: "right"}}>
				<div className="success_message"></div>
				<div className="title">
					<h4>Loan Types</h4>
				</div>
				
				<button id="add_new_row" href="#" style={mystyle} onClick={this.addNewRow.bind(this)} type="button" > <i class="fa fa-plus" aria-hidden="true"></i> Add</button>

				<BootstrapTable
				keyField="id"
				data={ datas }
				columns={ columns }
				cellEdit={ cellEditFactory({ mode: 'click', blurToSave: true, afterSaveCell: (oldValue, newValue, row, column) => { this.saveCellData(oldValue,newValue,row,column) } }) }
				
				deleteRow={ true }
				insertRow ={true}
				id='bt-table'
				
				/>

				</div>
				{/* </form> */}
				</div>	
			</div>	
		</div>
				
		</div>
		);
	}
}

export default (withRouter(Loantypes));